<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <b-jumbotron header="Faculty Workloads" lead="About">
          <p>
            Workload agreements are issued every spring semester for the following academic year. Workload agreements serve as a means of establishing expectations for faculty effort in the domains of research, teaching, service, and administration (if applicable). Faculty should work with their respective Assistant/Associate Dean to determine the most appropriate effort allocation given the faculty member’s track, rank, and grant coverage; this information is then communicated to program directors for teaching assignments.
          </p>
          <jumbo-widget heading="Analytics Reports">
            <b-row>
              <b-col>
                <div><a href="https://analytics.asu.edu/group/college-health-solutions-student-data/pages/college-health-solutions-student-data" target="_blank">CHS Student Data</a></div>

                <div><a href="https://analytics.asu.edu/group/college-health-solutions-faculty/pages/chs-faculty-analytics-home" target="_blank">CHS Faculty Analytics home page</a></div>

                <div><a href="https://analytics.asu.edu/group/classroom-scheduling/pages/schedule-classes-reports " target="_blank">Schedule of Classes Reports</a></div>

                <div><a href="https://analytics.asu.edu/group/college-health-solutions-student-data/actual-sch-instructor" target="_blank">View history of classes taught by instructor</a></div>

                <div><a href="https://analytics.asu.edu/group/college-health-solutions-student-data/all-classes-instructor" target="_blank">View all classes taught by instructor</a></div>
              </b-col>
            </b-row>
          </jumbo-widget>

          <div class="card">
            <div class="card-header">Request Help</div>
              <div class="card-body">
                <div class="mb-2">Experiencing issues with the application? Need access? Other questions? Use this link to let the application dev team know.</div>
                <div class="row">
                  <div class="col"><a href="https://links.asu.edu/chsapplicationintake">Submit Requests</a></div>
              </div>
            </div>
          </div>
        </b-jumbotron>
      </div>
    </div>
  </div>
</template>

<script>
import authApi from "../api/auth";
import JumboWidget from "../components/jumbo-widget.vue";
import roleChecks from "../misc/role-checks";

export default {
  mixins: [roleChecks],
  data() {
    return {};
  },
  components: {
    JumboWidget
  },
  created() {
    var that = this;

    // impersonate or stop impersonation
    var routeName = this.$route.name;
    if (routeName === "impersonation") {
      var asuriteId = this.$route.params.asuriteId;
      authApi
        .impersonate(asuriteId)
        .then(function() {
          that.$router.push({ path: "/" });
        })
        .catch(function(error) {
          console.log(error);
        });
    } else if (routeName === "stopimpersonation") {
      authApi
        .stopImpersonation()
        .then(function() {
          that.$router.push({ path: "/" });
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.display-3 {
  font-size: 2.5rem;
  font-weight: 300;
  line-height: 1.2;
}
</style>
